import { writable } from "svelte/store"
import { getParameterByName } from "../utils"

export const preselectedDealerNumber = writable<string>(null)
if (typeof window !== "undefined") {
    let _preselectedDealerNumber = getParameterByName("d")
    if (!_preselectedDealerNumber) {
        _preselectedDealerNumber = window.sessionStorage.getItem("preselectedDealerNumber")
    }

    preselectedDealerNumber.subscribe(function (n) {
        if (n) {
            window.sessionStorage.setItem("preselectedDealerNumber", n)
        } else {
            window.sessionStorage.removeItem("preselectedDealerNumber")
        }
    })
    if (_preselectedDealerNumber) {
        preselectedDealerNumber.set(_preselectedDealerNumber)
    }
}

export const iframeView = writable<boolean>(false)
if (typeof window !== "undefined") {
    let _iframeView = getParameterByName("iframe")
    if (!_iframeView) {
        _iframeView = window.sessionStorage.getItem("iframeView")
    }
    iframeView.subscribe(function (n) {
        if (n) {
            window.sessionStorage.setItem("iframeView", "1")
        } else {
            window.sessionStorage.removeItem("iframeView")
        }
    })
    if (_iframeView) {
        iframeView.set(true)
    }
}

export const referrer = writable<string>(null)
if (typeof document !== "undefined" && typeof window) {
    let _referrer = window.sessionStorage.getItem("referrer")

    // if stored referrer other host than current host
    if (_referrer && _referrer.indexOf(document.location.host) < 0) {
        // use it
    } else {
        _referrer = document.referrer
        window.sessionStorage.setItem("referrer", _referrer)
    }

    referrer.set(_referrer)
}

export const theme = writable<string>("light")
if (typeof window !== "undefined") {
    let _theme = getParameterByName("theme")
    if (!_theme) {
        _theme = window.sessionStorage.getItem("theme")
    }
    theme.subscribe(function (n) {
        if (n) {
            window.sessionStorage.setItem("theme", n)
        } else {
            window.sessionStorage.removeItem("theme")
        }
    })
    if (_theme) {
        theme.set(_theme)
    }
}

export const customizedTheme = writable<string>(null)
if (typeof window !== "undefined") {
    let _customizedTheme = getParameterByName("customized-theme")
    if (!_customizedTheme && typeof _customizedTheme !== "string") {
        _customizedTheme = window.sessionStorage.getItem("theme")
    }
    customizedTheme.subscribe(function (n) {
        if (n) {
            window.sessionStorage.setItem("customized-theme", JSON.stringify(n))

            // n is given p.e. as "background|ffffff,body|ffffff"
            // so we need to split it and set the css variables
            let vList = n.split(",").map((item) => {
                let i = item.split("|")
                return `--${i[0]}: #${i[1]}`
            })
            document.body.style.cssText = vList.join(";")
        } else {
            window.sessionStorage.removeItem("customized-theme")
            document.body.removeAttribute("style")
        }
    })
    if (typeof _customizedTheme === "string") {
        customizedTheme.set(_customizedTheme)
    }
}
